"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidServiceError = void 0;
class InvalidServiceError extends Error {
    constructor(name) {
        super(`InvalidServiceError ${name}`);
        Object.setPrototypeOf(this, InvalidServiceError.prototype);
    }
}
exports.InvalidServiceError = InvalidServiceError;
//# sourceMappingURL=InvalidServiceError.js.map